<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose"
             width="640px">
        <div class="row">
            <div class="col-12">
                <x-select v-model="form.warehouse_id"
                          label="Almacén de atención"
                          :options="warehouses"></x-select>
            </div>
            <div class="col-12">
                <x-input v-model="form.observations"
                         type="textarea"
                         label="Observaciones"></x-input>
            </div>
            <div class="col-12 table-responsive">
                <table class="table text-left">
                    <thead>
                    <tr>
                        <th style="width: 120px">Producto</th>
                        <th style="width: 120px">Cantidad</th>
                        <th style="width: 30px"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, index) in form.items" :key="index">
                        <td>{{ row.name }}</td>
                        <td>
                            <x-input v-model="row.quantity" :maxlength="row.quantity_initial"></x-input>
                        </td>
                        <td class="text-center">
                            <button class="btn waves-effect waves-light btn-xs btn-danger"
                                    type="button"
                                    @click.prevent="clickRemove(index)">
                                <i class="fa fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickClose" text="Cerrar"></x-button-cancel>
                <x-button-submit @click="onSubmit"
                                 v-if="form.items.length > 0"
                                 :disabled="loading"
                                 text="Generar"></x-button-submit>
            </div>
        </div>
    </x-modal>
</template>

<script>

import XButtonCancel from "../../../../components/Form/XButtonCancel";
import XButtonSubmit from "../../../../components/Form/XButtonSubmit";
import XModal from "../../../../components/XModal";
import XInput from "../../../../components/Form/XInput.vue";
import XSelect from "../../../../components/Form/XSelect.vue";
import XDatePicker from "../../../../components/Form/XDatePicker.vue";
import XInputItemSearch from "../../../../components/Form/XInputItemSearch.vue";
import moment from "moment/moment";

export default {
    name: 'TransferWarehouse',
    components: {XInputItemSearch, XDatePicker, XSelect, XInput, XModal, XButtonSubmit, XButtonCancel},
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
        recordId: null,
    },
    data() {
        return {
            title: null,
            loading: false,
            resource: 'inventory_transfer',
            errors: {},
            form: {},
            warehouses: []
        }
    },
    created() {
        this.initForm();
    },
    methods: {
        initForm() {
            this.title = '';
            this.errors = {};
            this.form = {
                id: null,
                document_id: this.recordId,
                warehouse_origin_id: null,
                warehouse_id: null,
                items: [],
                observations: null,
            };
            this.loading = false;
        },
        async handleOpen() {
            this.initForm()
            await this.$http.get(`/${this.resource}/get_document/${this.recordId}`)
                .then(response => {
                    this.warehouses = response.data.warehouses
                    this.form = Object.assign({}, this.form, response.data.form)
                })
            this.title = 'Registrar transferencia'
        },
        clickRemove(index) {
            this.form.items.splice(index, 1)
        },
        async onSubmit() {
            if (this.form.warehouse_id === null) {
                return this.$message.error('El almacén destino es requerido');
            }
            if (this.form.observations === null || this.form.observations === '') {
                return this.$message.error('La observación es requerida');
            }

            await this.$http.post(`/inventory_transfer`, this.form)
                .then(response => {
                    let res = response.data
                    if (res.success) {
                        this.$message.success(res.message);
                        this.$emit('success', res.data);
                        this.clickClose();
                    } else {
                        this.$message.error(res.message);
                    }
                })
        },
        clickClose() {
            this.$emit('update:showDialog', false)
        }
    }
}
</script>
